import axios, { AxiosResponse } from "axios";
import { ServiceURI } from "./ServiceURI";
import { FakeData } from "../fakeStorage/FakeData";

// Create an instance of Axios with default settings
const axiosInstance = axios.create({
  headers: {
    "Content-Type": "application/json",
  },
});

// Utility function to handle API calls
// const handleGETRequest = async <T>(
//   requestFn: () => Promise<AxiosResponse<T>>,
// ): Promise<any> => {
//   try {
//     const response = await requestFn();
//     return response.data;
//   } catch (error) {
//     return null;
//   }
// };

export const FakeAPIService = {
  postCall: (url: string): Promise<any> => {
    let mockData: any;
    return new Promise<any>((resolve) => {
      setTimeout(() => {
        resolve(mockData); // Resolve with mock data
      }, 200); // Simulate a delay
    });
  },
  getCall: (url: string): Promise<any> => {
    let mockData: any;
    switch (url) {
      case ServiceURI.AGENTS.FATCH_AGENTS:
        mockData = FakeData.FakeAgents;
        break;
      case ServiceURI.TEAMS.FATCH_TEAMS:
        mockData = FakeData.FakeTeams;
        break;
      case ServiceURI.TOOLS.FATCH_TOOLS:
        mockData = FakeData.FakeTools;
        break;
      case ServiceURI.KNOWLEDGE_BASE.FATCH_KNOWLEDGE_BASE:
        mockData = FakeData.FakeKnowledgeBase;
        break;
      case ServiceURI.GUARDRAILS.FATCH_GUARDRAILS:
        mockData = FakeData.FakeGuards;
        break;
      default:
        mockData = [];
    }
    return new Promise<any>((resolve) => {
      setTimeout(() => {
        resolve(mockData); // Resolve with mock data
      }, 500); // Simulate a delay
    });
  },
};

// Utility function to handle API calls
const handleRESTRequest = async <T>(
  requestFn: () => Promise<AxiosResponse<T>>,
): Promise<any> => {
  try {
    const response = await requestFn();
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const APIService = {
  postCall: (url: string, payload: any): Promise<any> => {
    return handleRESTRequest(() => axiosInstance.post(url, payload));
  },

  getCall: (url: string): Promise<any> => {
    return FakeAPIService.getCall(url);
    // return handleGETRequest(() => axiosInstance.get(url));
  },

  putCall: (url: string, id: string, payload: any): Promise<any> => {
    return handleRESTRequest(() => axiosInstance.put(`${url}/${id}`, payload));
  },

  deleteCall: (url: string, id: string): Promise<any> => {
    return handleRESTRequest(() => axiosInstance.delete(`${url}/${id}`));
  },
};
